import PropTypes from "prop-types";
import clsx from "clsx";
import { Divider, Grid, Typography } from "@material-ui/core";
import { LinkKeepUTM } from "../../../../../shared/components/LinkKeepUTM";
import { useStyles } from "./taskCard.styles";
import { EventsIcon } from "../../../../../shared/icons";
import { formattedDate } from "../../../../../shared/formattedDate";

export const TaskCard = ({
  title,
  description,
  dueDate,
  completed,
  score,
  todoId,
}) => {
  const classes = useStyles();

  const truncateString = (str, max) =>
    str.length > max ? `${str.slice(0, max)} ...` : str;

  const truncatedTitle = truncateString(title, 245);
  const truncatedDesctiption = truncateString(description, 315);

  return (
    <Grid item xs={12} md={4} lg={3}>
      <Grid
        container
        direction="column"
        className={classes.taskContainer}
        component={LinkKeepUTM}
        to={`/participant/tasks/${todoId}`}
      >
        <Grid item className={classes.titleDescription}>
          <Typography className={classes.taskTitle}>
            {truncatedTitle}
          </Typography>
          <Typography className={classes.taskDescription}>
            {truncatedDesctiption}
          </Typography>
        </Grid>
        <Grid
          container
          direction="column"
          justifyContent="space-between"
          alignItems="flex-start"
          className={classes.infoContainer}
        >
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            className={classes.dueDateContainer}
          >
            {dueDate && (
              <>
                <EventsIcon className={classes.dueDateIcon} />
                <Typography className={classes.dueDate}>
                  {formattedDate(dueDate)}
                </Typography>
              </>
            )}
          </Grid>
          <Divider style={{ width: "100%" }} />
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid
              item
              className={clsx({
                [classes.completedLabel]: completed,
                [classes.notCompletedLabel]: !completed,
              })}
            >
              {completed ? "Completed" : "Not started"}
            </Grid>
            <Grid item>
              {score > 0 && (
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  className={classes.scoreContainer}
                >
                  <Typography className={classes.scoreNumber}>
                    {score}
                  </Typography>
                  <Typography className={classes.scoreText}>PTS.</Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

TaskCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  dueDate: PropTypes.string,
  completed: PropTypes.bool,
  score: PropTypes.number,
  todoId: PropTypes.number.isRequired,
};

TaskCard.defaultProps = {
  title: "",
  description: "",
  dueDate: "",
  completed: false,
  score: 0,
};
